import { render, staticRenderFns } from "./m_privacy.vue?vue&type=template&id=1df6604a&"
import script from "./m_privacy.vue?vue&type=script&lang=js&"
export * from "./m_privacy.vue?vue&type=script&lang=js&"
import style0 from "./m_privacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports